import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-s-alert';

import Snoozes from 'api/resources/snoozes';
import { processErrorByAlert } from 'utils/getErrors';

import DeleteIcon from 'icons/Delete';

import EditSnooze from 'admin-editor/containers/EditSnooze';

import ConfirmModal from 'components/ConfirmModal';
import Footer from 'components/ConfirmModal/Footer';
import Text from 'components/ConfirmModal/Text';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';

import ListItemRow from 'styled/ListItemRow';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import SimpleButton from 'styled/Buttons/SimpleButton';

import SnoozeName from './SnoozeName';

class SnoozesInactiveItem extends React.PureComponent {
  state = {
    loading: false,
    isEditSnoozeOpen: false,
    confirmIsOpen: false,
    name: this.props.name,
  }

  handleEditOpenClick = () => {
    this.setState({ isEditSnoozeOpen: true });
  }

  handleEditCloseClick = () => {
    this.setState({ isEditSnoozeOpen: false });
  }

  handleOpenConfirmClick = () => {
    this.setState({ confirmIsOpen: true });
  }

  handleCloseConfirmClick = () => {
    this.setState({ confirmIsOpen: false });
  }

  handleSnoozeUpdate = (name) => {
    this.setState({ name });
  }

  handleDeleteClick = async () => {
    this.setState({ loading: true });

    try {
      await Snoozes.delete({ snoozeId: this.props.id });

      this.setState({ confirmIsOpen: false });
      Alert.success('Снуз успешно удалён');
      this.props.onSnoozesUpdate({ id: this.props.id });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  handleActivateClick = async () => {
    this.setState({ loading: true });

    try {
      await Snoozes.patch({
        snoozeId: this.props.id,
        body: {
          data: {
            type: 'snooze',
            attributes: { is_active: true },
          },
        },
       });

      Alert.success('Снуз успешно активирован');
      this.setState({ loading: false });
      this.props.onSnoozesUpdate({ id: this.props.id, reloadOnActivateSnooze: true });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <ListItemRow>
        <ConfirmModal onClose={this.handleCloseConfirmClick} isOpen={this.state.confirmIsOpen}>
          <Content>
            <Title>Удаление</Title>

            <Text>Вы точно хотите удалить снуз {this.props.name}?</Text>
          </Content>

          <Footer>
            <PrimaryButton
              type="button"
              onClick={this.handleDeleteClick}
              autoFocus
              style={{ marginRight: '10px' }}
              disabled={this.state.loading}
            >
              Удалить
            </PrimaryButton>

            <SecondaryButton
              type="button"
              onClick={this.handleCloseConfirmClick}
            >
              Отмена
            </SecondaryButton>
          </Footer>
        </ConfirmModal>

        <SnoozeName>{this.state.name}</SnoozeName>

        <PrimaryButton
          type="button"
          style={{ marginRight: '16px', marginLeft: 'auto' }}
          onClick={this.handleActivateClick}
          disabled={this.state.loading}
        >
          активировать
        </PrimaryButton>

        <SecondaryButton
          type="button"
          style={{ marginRight: '24px' }}
          onClick={this.handleEditOpenClick}
        >
          редактировать
        </SecondaryButton>

        <SimpleButton type="button" onClick={this.handleOpenConfirmClick}>
          <DeleteIcon />
        </SimpleButton>

        {this.state.isEditSnoozeOpen && (
          <EditSnooze
            onClose={this.handleEditCloseClick}
            id={this.props.id}
            onSnoozeUpdate={this.handleSnoozeUpdate}
            contentLabel="Редактирование снуза"
          />
        )}
      </ListItemRow>
    );
  }
}

SnoozesInactiveItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSnoozesUpdate: PropTypes.func,
};

SnoozesInactiveItem.defaultProps = {
  onSnoozesUpdate: () => {},
};

export default SnoozesInactiveItem;
